import { Skeleton } from "@mui/material";
import { useContextApi } from "../context/ContextApi";

const Table = ({
    columns = [],
    data = [],
    loading = false,
    skeletonRows = 10,
    onRowClick,
    isDragable = false,
    paddingTopBottom="",
    onRowDragStart, 
    trClass=false,
    hoverRow=true,
    howerClass='hover-row',
    wrapperClass = ""
  }) => {
    const {getColor}=useContextApi();
    return (
      <div className={`table-responsive mt-3 ${wrapperClass}`}>
        <table className="table align-middle mb-0">
          <thead className="table-light text-center">
            <tr>
              {columns.map(
                (col, idx) =>
                  col.show !== false && <th key={idx} className={col?.thClass}>{col.label}</th>
              )}
            </tr>
          </thead>
  
          <tbody>
            {loading ? (
              [...Array(skeletonRows)].map((_, index) => (
                <tr key={index}>
                  {columns.map(
                    (col, i) =>
                      col.show !== false && (
                        <td key={i} className={`text-center ${paddingTopBottom}`}>
                          <Skeleton variant="text" width={150} />
                        </td>
                      )
                  )}
                </tr>
              ))
            ) : data?.length > 0 ? (
              data?.map((item, rowIndex) => (
                <tr
                  key={rowIndex}
                   draggable={isDragable}
                      onDragStart={(e) => {
                        e.currentTarget.classList.add("dragging-row");
                  if (isDragable && onRowDragStart) {
                    onRowDragStart(e, item, rowIndex);
                  }
                }}
                onDragEnd={(e) => {
                  e.currentTarget.classList.remove("dragging-row");
                }}
                  className={`position-relative cursor-pointer ${hoverRow?`${howerClass}`:""} ${trClass?(item?.expiredate?getColor(item?.expiredate):""):""}`}
                  onClick={() => onRowClick && onRowClick(item,rowIndex)}
                  data-item={JSON.stringify(item)}
                >
                  {columns.map(
                    (col, colIndex) =>
                      col?.show !== false && (
                        <td key={colIndex} className={`text-center ${col?.tdBodyclass} ${paddingTopBottom}`} width={col?.tdWidth}>
                          {col?.render ? col.render(item, rowIndex) : item[col.key] ?? "-"}
                        </td>
                      )
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.filter(c => c.show !== false).length} className="text-center p-2 text-muted">
                  No records found in the store.Add some to get started.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };
  
  export default Table;
  